package com.evoapps.evoshift.domain.util

/**
 * Failures the domain keeps going after (best-effort writes such as a shift's cost snapshot) but
 * that must not vanish: reported as non-fatals. The app installs its telemetry here
 * (AppTelemetry.install); until then, and in tests, nothing is reported.
 */
object DomainErrors {
    private var reporter: (Throwable) -> Unit = {}

    fun install(report: (Throwable) -> Unit) {
        reporter = report
    }

    fun report(throwable: Throwable) {
        runCatching { reporter(throwable) }
    }
}

/** A best-effort cost snapshot write that failed for another reason than missing pay rates. */
class ShiftPricingFailedException(val shiftId: String, cause: Throwable) :
    Exception("Pricing shift $shiftId failed: ${cause::class.simpleName}: ${cause.message}", cause)

/**
 * SH-188: the server refused a live read of a workplace's data under the security rules: the
 * person no longer works there (their engagement ended) or their role changed. Distinct from an
 * empty result, so a screen says "You no longer have access" instead of showing nothing.
 */
class WorkplaceAccessRevokedException(cause: Throwable? = null) : Exception("Access to the workplace was revoked", cause)
